
const isJSON = (str)=> {
  try {
    return (typeof JSON.parse(str) === 'object')
  } catch (e) {
    return false
  }
}
export default isJSON
